import {
  LOGO_SIZE_MEDIUM,
  NAME_ABOVE_PRODUCT_LAYOUT,
  ROUND_LOGO_WITH_BORDER,
  STORIES,
} from "../components/WorkSpace/CanvasViewer/EncarteConstants";
import { POPPINS_FONT } from "../components/WorkSpace/ToolBarMenuViews/StylesMenuView/useFormatFontFamily";

export default function Styles(
  bgColor = "#f8a617",
  txtColor = "black",
  priceTxtColor = "#F8FAFC",
  fontFamily = POPPINS_FONT,
  format = STORIES,
  fontSize = "32",
  productLayout = NAME_ABOVE_PRODUCT_LAYOUT,
  priceStyle = 1,
  logoStyle = ROUND_LOGO_WITH_BORDER,
  gridColumn = "",
  gridRow = "",
  footerStyle = "FULL_DETAILS",
) {
  return {
    bgColor: bgColor,
    txtColor: txtColor,
    fontFamily: fontFamily,
    format: format,
    fontSize: fontSize,
    priceTxtColor: priceTxtColor,
    productLayout: productLayout,
    priceStyle: priceStyle,
    logoStyle: logoStyle,
    gridColumn: gridColumn,
    gridRow: gridRow,
    footerStyle: footerStyle,
  };
}
